export enum CommunicationType {
    Email = 1,
    Mobile = 2,
    Web = 4,
}
